import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Heading,
  Expander,
  ExpanderTitleButton,
  ExpanderContent
} from 'suomifi-ui-components';
import List from '../components/List';
import { DataProtectionPreview } from './DataProtectionPreview';
import MessagesPreviewList from '../components/MessagesPreviewList/MessagesPreviewList';

const NotificationContacts = ({ contacts, i18n }) =>
  contacts.map((contact, i) => (
    <>
      {i > 0 ? <hr className="my-4 w-50 ml-0" /> : null}
      <List key={`notification-contact-${i}`}>
        <List.Item
          title={i18n('intermediary.preview.firstName')}
          value={contact?.contactFirstName}
        />
        <List.Item
          title={i18n('intermediary.preview.lastName')}
          value={contact?.contactLastName}
        />
        <List.Item
          title={i18n('intermediary.preview.email')}
          value={contact?.contactEmail}
        />
        <List.Item
          title={i18n('intermediary.preview.phone')}
          value={contact?.contactPhone}
        />
      </List>
    </>
  ));

export const MessagesPreview = ({ formData, i18n, defaultOpen = true }) => (
  <React.Fragment>
    <Expander defaultOpen={defaultOpen}>
      <ExpanderTitleButton>
        <FormattedMessage id="intermediary.serviceInfo.formTitle" />
      </ExpanderTitleButton>
      <ExpanderContent>
        {formData.serviceData?.services?.map((service, i) => (
          <React.Fragment key={`service-${service.name || i}`}>
            {i > 0 ? <hr className="my-4" /> : null}
            <MessagesPreviewList
              version={formData.formSchemaVersion}
              i18n={i18n}
              service={service}
            />
            <Heading variant="h4" className="my-2">
              <FormattedMessage id="forms.viestit_registration.page_messagesInfo.notificationSection.title" />
            </Heading>
            <NotificationContacts
              contacts={service.notificationContacts}
              i18n={i18n}
            />
          </React.Fragment>
        ))}
      </ExpanderContent>
    </Expander>

    <DataProtectionPreview
      i18n={i18n}
      defaultOpen={defaultOpen}
      formData={formData}
    />
  </React.Fragment>
);

MessagesPreview.propTypes = {
  i18n: PropTypes.func,
  formData: PropTypes.object,
  defaultOpen: PropTypes.bool
};
